"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customFailure = exports.customSuccess = exports.customRequest = exports.saveFailure = exports.saveSuccess = exports.saveRequest = exports.fetchOneFailure = exports.fetchOneSuccess = exports.fetchOneRequest = exports.fetchFailure = exports.fetchSuccess = exports.fetchRequest = void 0;
const types = require("./types");
const fetchRequest = (objectType) => ({
    objectType,
    type: types.FETCH_REQUEST
});
exports.fetchRequest = fetchRequest;
const fetchSuccess = (objectType, workspaceId, items, metadata) => ({
    objectType,
    workspaceId,
    items,
    metadata,
    type: types.FETCH_SUCCESS
});
exports.fetchSuccess = fetchSuccess;
const fetchFailure = (objectType, errorMessage) => ({
    errorMessage,
    objectType,
    type: types.FETCH_FAILURE
});
exports.fetchFailure = fetchFailure;
const fetchOneRequest = (objectType, objectId) => ({
    objectType,
    objectId,
    type: types.FETCHONE_REQUEST
});
exports.fetchOneRequest = fetchOneRequest;
const fetchOneSuccess = (objectType, objectId, workspaceId, item) => ({
    objectType,
    objectId,
    workspaceId,
    item,
    type: types.FETCHONE_SUCCESS
});
exports.fetchOneSuccess = fetchOneSuccess;
const fetchOneFailure = (objectType, objectId, errorMessage) => ({
    errorMessage,
    objectType,
    objectId,
    type: types.FETCHONE_FAILURE
});
exports.fetchOneFailure = fetchOneFailure;
const saveRequest = (objectType, objectId) => ({
    objectType,
    objectId,
    type: types.SAVE_REQUEST
});
exports.saveRequest = saveRequest;
const saveSuccess = (objectType, objectId, workspaceId, item) => ({
    objectType,
    workspaceId,
    objectId,
    item,
    type: types.SAVE_SUCCESS
});
exports.saveSuccess = saveSuccess;
const saveFailure = (objectType, objectId, errorMessage) => ({
    errorMessage,
    objectType,
    objectId,
    type: types.SAVE_FAILURE
});
exports.saveFailure = saveFailure;
const customRequest = (statePath) => ({
    statePath,
    type: types.CUSTOM_REQUEST
});
exports.customRequest = customRequest;
const customSuccess = (statePath, workspaceId, data, reducers) => ({
    statePath,
    workspaceId,
    data,
    reducers,
    type: types.CUSTOM_SUCCESS
});
exports.customSuccess = customSuccess;
const customFailure = (statePath, errorMessage) => ({
    errorMessage,
    statePath,
    type: types.CUSTOM_FAILURE
});
exports.customFailure = customFailure;
//# sourceMappingURL=actions.js.map